'use client';

import React, { useState, useEffect } from 'react';
import SocialMediaBar from './SocialMediaBar';

export default function FloatingSocialBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed left-4 top-1/2 -translate-y-1/2 z-40 transition-all duration-500 hidden xl:flex ${
        visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8 pointer-events-none'
      }`}
    >
      <div className="flex flex-col gap-1">
        <div className="text-[9px] font-mono font-semibold text-foreground-subtle uppercase tracking-widest mb-1 text-center" style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)', letterSpacing: '0.2em' }}>
          Follow Us
        </div>
        <SocialMediaBar variant="vertical" size="sm" />
        <div className="w-px h-8 bg-border mx-auto mt-1" />
      </div>
    </div>
  );
}
